import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Helmet ,HelmetProvider} from "react-helmet-async";  // ✅ Import Helmet
import Home from "./pages/Home";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <Router>
      <>
      <HelmetProvider>
          {/* ✅ Global SEO Meta (default across all routes) */}
        <Helmet>
          <title>INBI NextGen Innovations – Custom Software, IoT & ERP Solutions in India</title>
          <meta
            name="description"
            content="INBI NextGen Innovations builds future-ready software, IoT, and ERP solutions tailored to your business needs. Over 27 years of expertise. Contact us today."
          />
          {/* Optional: Social media previews */}
          <meta property="og:title" content="INBI NextGen Innovations – Custom Software, IoT & ERP Solutions in India" />
          <meta property="og:description" content="Future-ready software, IoT, and ERP solutions with 27+ years of expertise. Contact us today!" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://www.inbi.in" />
          <meta property="og:site_name" content="INBI NextGen Innovations" />
          <meta name="twitter:card" content="summary_large_image" />
        </Helmet>
      </HelmetProvider>

        {/* Routes */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/index.html" element={<Navigate to="/" replace />} />
          <Route path="/#home" element={<Navigate to="/"/>} />
          <Route path="/privacy" element={<Navigate to="/" />} />
          <Route path="/terms" element={<Navigate to="/" />} />
        </Routes>

        <ScrollToTop />
        <Footer />
      </>
    </Router>
  );
}

export default App;
